import { EnumHelper } from "@/Common/Helpers/EnumHelper";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { EnumMyleLoginPermission } from "@/Common/Models/EnumMyleLoginPermission";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { PermissionType } from "./PermissionType";

class Permission {
    public Id: string;
    public Name: string;
    public Type: PermissionType;

    /**
     * Return all visible permission by an employee
     * @param employee current employee
     * @returns {Permission} filtered permissions
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public static getPermissionsByEmployee(employee: EmployeeUIModel): Permission[] {
        let allPermissions: Permission[] = cacheStore.Permissions ?? [];

        if (employee.Type === EmployeeType.Api) {
            allPermissions = allPermissions.filter(p => p.Type === PermissionType.ForApi);
        }
        else {
            const loginPermissions = EnumHelper.getNames(EnumMyleLoginPermission);

            allPermissions = allPermissions.filter(p => p.Type !== PermissionType.ForApi && loginPermissions.includes(p.Name));

            const hideCanCreatePatientPermission = cacheStore.ClinicSettings?.EnablePatientEdit || !cacheStore.ClinicSettings?.EnableCanCreatePatientPermission;
            if (hideCanCreatePatientPermission) {
                allPermissions = allPermissions.filter(p => p.Name !== "CanCreateAndEditPatientPermission");
            }

            if (!cacheStore.hasInboundFaxPermission()) {
                allPermissions = allPermissions.filter(p => p.Name !== "InboundFaxPermission");
            }

            if (!cacheStore.ClinicSettings?.EnablePrescriptionRenewal) {
                allPermissions = allPermissions.filter(p => p.Name !== "PrescriptionRenewalTabPermission");
            }

            if (!cacheStore.ClinicSettings?.EnableBillingReconciliationReport)
                allPermissions = allPermissions.filter(p => p.Name !== "PublicBillingPermission" && p.Name !== "PrivateBillingPermission");

            if (!cacheStore.ClinicSettings?.EnablePharmacyOrders) {
                allPermissions = allPermissions.filter(p => p.Name !== "OrdersTabPermission");
            }

            if (!cacheStore.ClinicSettings?.EnableUserPatientAutoMergeRequest) {
                allPermissions = allPermissions.filter(p => p.Name !== "Administration_PatientMergeRequestPermission");
            }
        }

        return allPermissions;
    }

    public static GetByEnum(permissionEnum: EnumMyleLoginPermission): Permission | null {
        const permissionName = EnumHelper.getName(EnumMyleLoginPermission, permissionEnum);
        return cacheStore.Permissions?.firstOrDefault(p => p.Name === permissionName);
    }

    public static GetById(permissionId: string): Permission | null {
        return cacheStore.Permissions?.firstOrDefault(p => p.Id === permissionId);
    }
}

export { Permission };
